import { render } from "./CaseClusterAcknowledgment.vue?vue&type=template&id=556544aa&ts=true"
import script from "./CaseClusterAcknowledgment.vue?vue&type=script&lang=ts"
export * from "./CaseClusterAcknowledgment.vue?vue&type=script&lang=ts"

import "./CaseClusterAcknowledgment.vue?vue&type=style&index=0&id=556544aa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__